module.exports = "/assets/data/bb6895351d54fe938e672ff12e7e9847-CO16.data.json";